module.exports = __webpack_public_path__ + "417e3f38dcbc1edeef7a1a6c21692e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Display/Components/PlayPause/play_white.png
// module id = 174
// module chunks = 6